import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

interface PopoverStore {
  activePopoverId: string | null;
}

interface PopoverActions {
  setActivePopover: (popoverId: string | null) => void;
  closeAllPopovers: () => void;
}

const usePopoverStore = create<PopoverStore & PopoverActions>((set) => ({
    activePopoverId: null,
    setActivePopover: (popoverId) => set({ activePopoverId: popoverId }),
    closeAllPopovers: () => set({ activePopoverId: null }),
}));

export const usePopoverManager = (popoverId: string) => {
    const { activePopoverId, setActivePopover, closeAllPopovers } = usePopoverStore(
        useShallow((state) => ({
            activePopoverId: state.activePopoverId,
            setActivePopover: state.setActivePopover,
            closeAllPopovers: state.closeAllPopovers,
        }))
    );

    const isOpen = activePopoverId === popoverId;

    const openPopover = () => setActivePopover(popoverId);
    const closePopover = () => {
        if (activePopoverId === popoverId) {
            setActivePopover(null);
        }
    };

    const togglePopover = () => (isOpen ? closePopover() : openPopover());

    return {
        isOpen,
        openPopover,
        closePopover,
        togglePopover,
        closeAllPopovers,
    };
};

export { usePopoverStore };
